export const CANVAS_HEIGHT = 80;
export const CANVAS_BORDERS_WIDTH = 2;
export const PEN_WIDTH = 1.5;
export const SIGNATURE_FONT_SIZE = 48;
export const SIGNATURE_FONT_FAMILY = '"Nanum Pen Script", cursive';
